var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOfflineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12.1701L23 10.1701C19.27 6.44006 14.13 5.02006 9.3 5.86006L11.88 8.44006C15.18 8.42006 18.49 9.66006 21 12.1701ZM19 14.1701C17.92 13.0901 16.64 12.3201 15.28 11.8401L18.3 14.8601L19 14.1701ZM9 18.1701L12 21.1701L15 18.1701C13.35 16.5101 10.66 16.5101 9 18.1701ZM3.41 2.81006L2 4.22006L5.05 7.27006C3.59 8.00006 2.22 8.96006 1 10.1701L3 12.1701C4.23 10.9401 5.65 10.0101 7.17 9.39006L9.41 11.6301C7.79 12.0601 6.27 12.9101 5 14.1701L7 16.1701C8.35 14.8201 10.11 14.1301 11.89 14.1101L18.97 21.1901L20.38 19.7801L3.41 2.81006Z",
    fill: "#C80000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOfflineIcon);
export default __webpack_public_path__ + "static/media/OfflineIcon.531952f1.svg";
export { ForwardRef as ReactComponent };